module.exports = __webpack_public_path__ + "img/8.4847dd13.png";